<template>
  <vbt-dialog
    v-model="dialog"
    hide-submit-btn
    title="Token payload information"
  >
    <v-layout
      v-for="(config, i) in drawConfig"
      :key="`${config.key}-${i}`"
      align-center
    >
      <v-flex sm3>
        <strong>
          {{ config.text }}
        </strong>
      </v-flex>
      <v-flex sm9>
        <v-text-field
          v-if="config.type === 'input'"
          :value="parsedPayload[config.key]"
          disabled
          readonly
        />
        <v-text-field
          v-if="config.type === 'date'"
          :value="formatDisplayDate(parsedPayload[config.key])"
          disabled
          readonly
        />
        <ul
          v-if="config.type === 'list'"
          class="my-4"
        >
          <li
            v-for="(item, j) in parsedPayload[config.key]"
            :key="`li-${j}`"
          >
            {{ item }}
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </vbt-dialog>
</template>

<script>
import { useDialog } from '@mixins/factories';

import { formatDisplayDate } from '@helpers';

const drawConfig = Object.freeze([
  { key: 'Issuer', text: 'Issuer', type: 'input' },
  { key: 'Audience', text: 'Audience', type: 'input' },
  { key: 'Subject', text: 'Subject', type: 'input' },
  { key: 'Name', text: 'Name', type: 'input' },
  { key: 'UniqueName', text: 'Unique Name', type: 'input' },
  { key: 'Email', text: 'Email', type: 'input' },
  { key: 'Version', text: 'Version', type: 'input' },
  { key: 'AppName', text: 'App Name', type: 'input' },
  { key: 'Roles', text: 'Roles', type: 'list' },
  { key: 'Created', text: 'Created', type: 'date' },
  { key: 'NotBefore', text: 'Not Before', type: 'date' },
  { key: 'Expires', text: 'Expires', type: 'date' },
]);

export default {
  name: 'UmsTokenViewer',
  props: {
    payload: {
      type: String,
      default: '',
    },
  },
  mixins: [
    useDialog(),
  ],
  data: () => ({ drawConfig }),
  computed: {
    parsedPayload() {
      try {
        return JSON.parse(this.payload);
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    formatDisplayDate,
  },
};
</script>
